import {Component, OnInit} from '@angular/core';
import {IdService} from "../../services/id/id.service";
import {ActivatedRoute, Router} from "@angular/router";
import {PermissionsService} from "../../services/permissions/permissions.service";
import Constants from "../../shared/constants";
import {environment} from "../../../environments/environment";
import * as Cookies from 'js-cookie';

@Component({
    selector: 'xlog-signup-verify',
    templateUrl: './signup-verify.component.pug',
    styleUrls: ['./signup-verify.component.scss'],
    standalone: false
})
export class SignupVerifyComponent implements OnInit {
    loaded = false;
    token = '';
    email = '';

    constructor(
        private id: IdService,
        private router: Router,
        private route: ActivatedRoute,
        public featureFlagService: PermissionsService
    ) {
    }

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            this.token = params['t'];
            this.email = params['email'] ? params['email'].replace(/ /g, '+') : null;
            if (!this.token || !this.email) {
                this.router.navigate(['signup/expired']);
            }
        });
        this.loaded = false;
        this.id.verifySignupToken(this.token, this.verifySignupTokenSuccess, this.validationError);
    }

    verifySignupTokenSuccess = (data: any) => {
        this.id.getDomainMapping(this.token).subscribe(
            (response: any) => {
                this.loaded = true;
                if (response.data?.mapping_status === 'contact_support') {
                    // redirect to p11
                    this.router.navigate(['/signup/manual-upgrade'], {
                        queryParams: {
                            t: this.token
                        }
                    });
                } else if (response.data?.mapping_status === 'join') {
                    // redirect to p8
                    const orgData = response.data?.org_data;
                    this.router.navigate(['/signup/join-team'], {
                        queryParams: {
                            t: this.token,
                            email: this.email
                        },
                        state: {data: orgData}
                    });
                } else if (response.data?.mapping_status === 'create') {
                    // redirect to p3
                    window.location.href = `/user-details/${encodeURIComponent(this.email)}?t=${encodeURIComponent(this.token)}`;
                }
            },
            (error: any) => {
                console.error(error);
                this.loaded = true;
                if (error.status === 401) {
                    this.router.navigate(['signup/expired']);
                } else {
                    const locale = Cookies.get(Constants.LOCALE_TOKEN);
                    const omniLocales = Constants.OMNI_LOCALES;
                    let returnUrl;

                    if (locale && omniLocales.includes(locale)) {
                        returnUrl = environment.SIGNUP_URL + locale.toUpperCase() + '/error';
                    } else {
                        returnUrl = environment.SIGNUP_URL + 'EN-AU/error';
                    }
                    window.location.href = returnUrl;
                }
            }
        );
    };

    validationError = (error: any) => {
        this.loaded = true;
        this.router.navigate(['/signup/expired']);
    };
}
